import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Header from '../../Components/Header/Header';
import api from '../../api';
import { STEP_BADGE, errorMessage, isBusy, timeAgo } from './docShared';
import './documentaries.css';

function DocumentaryList() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const load = useCallback(() => {
    return api.get('/visual-engine/videos', { params: { limit: 60 } })
      .then((r) => { setVideos(r.data.videos || []); setError(''); })
      .catch((e) => setError(errorMessage(e)))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  // refresh while something is making a voice or rendering
  useEffect(() => {
    if (!videos.some(isBusy)) return undefined;
    const t = setInterval(load, 6000);
    return () => clearInterval(t);
  }, [videos, load]);

  return (
    <div className="docs-page">
      <Header />
      <main className="docs-main">
        <div className="docs-head">
          <div>
            <h1>Documentaries</h1>
            <p>Script → voice &amp; timings → plan with Claude → render.</p>
          </div>
          <div className="docs-head__actions">
            <Link to="/documentaries/brand-kits" className="docs-btn docs-btn--ghost">Brand kits</Link>
            <Link to="/documentaries/new" className="docs-btn docs-btn--primary">New documentary</Link>
          </div>
        </div>

        {error && <div className="docs-alert docs-alert--bad">{error}</div>}

        {loading ? (
          <div className="docs-empty">Loading…</div>
        ) : videos.length === 0 ? (
          <div className="docs-empty">
            <h3>No documentaries yet</h3>
            <p>Start with a script. You will get the timings to plan the video with Claude.</p>
            <Link to="/documentaries/new" className="docs-btn docs-btn--primary">Start your first one</Link>
          </div>
        ) : (
          <div className="docs-list">
            {videos.map((v) => {
              const badge = STEP_BADGE[v.step] || { text: v.status, tone: 'muted' };
              return (
                <button key={v.id} className="docs-row" onClick={() => navigate(`/documentaries/${v.id}`)}>
                  <div className="docs-row__main">
                    <span className="docs-row__title">{v.title}</span>
                    <span className="docs-row__meta">
                      {v.request?.brand?.channel_name || 'No channel'} · {timeAgo(v.updated_at || v.created_at)}
                      {v.renders > 1 ? ` · ${v.renders} renders` : ''}
                    </span>
                  </div>
                  {isBusy(v) && (
                    <div className="docs-row__progress" aria-label="progress">
                      <div style={{ width: `${Math.round((v.progress || 0) * 100)}%` }} />
                    </div>
                  )}
                  <span className={`docs-badge docs-badge--${badge.tone}`}>
                    {v.status === 'queued' && v.queue_position ? `In line #${v.queue_position}` : badge.text}
                  </span>
                </button>
              );
            })}
          </div>
        )}
      </main>
    </div>
  );
}

export default DocumentaryList;
